/* ============================================
   AROHABLISS ENHANCEMENTS - JavaScript
   Scroll reveal, header scroll state, smooth interactions
   ============================================ */

(function() {
  'use strict';

  /* --- Header Scroll State --- */
  const header = document.querySelector('.section-header');
  if (header) {
    let lastScroll = 0;
    const onScroll = () => {
      const scrollY = window.scrollY;
      if (scrollY > 30) {
        header.classList.add('scrolled-past-header');
      } else {
        header.classList.remove('scrolled-past-header');
      }
      lastScroll = scrollY;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // initial check
  }

  /* --- Scroll Reveal (IntersectionObserver) --- */
  const revealElements = document.querySelectorAll(
    '.card-wrapper, .collection-card, .article-card, .subbanner__item, .service-item, .footer-block, .multicolumn-card'
  );

  if (revealElements.length > 0 && 'IntersectionObserver' in window) {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!prefersReducedMotion) {
      revealElements.forEach(el => el.classList.add('ab-reveal'));

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry, index) => {
            if (entry.isIntersecting) {
              // Stagger delay based on position within viewport batch
              const delay = Math.min(index * 80, 400);
              setTimeout(() => {
                entry.target.classList.add('ab-visible');
              }, delay);
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -40px 0px',
        }
      );

      revealElements.forEach(el => observer.observe(el));
    }
  }

  /* --- Announcement Bar Dismiss --- */
  const announcementBar = document.querySelector('.announcement-bar-section');
  if (announcementBar) {
    // Create close button
    const closeBtn = document.createElement('button');
    closeBtn.className = 'ab-announcement-close';
    closeBtn.setAttribute('aria-label', 'Close announcement');
    closeBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>';
    closeBtn.style.cssText = 'position:absolute;right:16px;top:50%;transform:translateY(-50%);background:rgba(255,255,255,0.1);border:none;color:inherit;cursor:pointer;padding:6px;border-radius:50%;display:flex;align-items:center;justify-content:center;transition:background 200ms;z-index:2;';

    closeBtn.addEventListener('mouseenter', () => { closeBtn.style.background = 'rgba(255,255,255,0.2)'; });
    closeBtn.addEventListener('mouseleave', () => { closeBtn.style.background = 'rgba(255,255,255,0.1)'; });

    closeBtn.addEventListener('click', () => {
      announcementBar.style.transition = 'max-height 300ms ease, opacity 200ms ease';
      announcementBar.style.maxHeight = announcementBar.scrollHeight + 'px';
      requestAnimationFrame(() => {
        announcementBar.style.overflow = 'hidden';
        announcementBar.style.maxHeight = '0';
        announcementBar.style.opacity = '0';
      });
      sessionStorage.setItem('ab-announcement-dismissed', '1');
    });

    // Only add if not already dismissed this session
    if (!sessionStorage.getItem('ab-announcement-dismissed')) {
      const firstBar = announcementBar.querySelector('.announcement-bar');
      if (firstBar) {
        firstBar.style.position = 'relative';
        firstBar.appendChild(closeBtn);
      }
    } else {
      announcementBar.style.display = 'none';
    }
  }

  /* --- Product Card Enhanced Hover --- */
  document.querySelectorAll('.card-wrapper').forEach(card => {
    const quickAdd = card.querySelector('.quick-add');
    if (quickAdd) {
      quickAdd.style.transition = 'opacity 300ms ease, transform 300ms ease';
    }
  });

  /* --- Smooth section heading reveal --- */
  const sectionHeadings = document.querySelectorAll('.section-heading, .title-wrapper, .collection-list-title, h2.title');
  if (sectionHeadings.length > 0 && 'IntersectionObserver' in window) {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!prefersReducedMotion) {
      sectionHeadings.forEach(el => el.classList.add('ab-reveal'));
      const headingObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('ab-visible');
              headingObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.2 }
      );
      sectionHeadings.forEach(el => headingObserver.observe(el));
    }
  }

})();
